module.exports = __webpack_public_path__ + "img/xmark-solid.a40fdb45.svg";